var moduleMap = {
	"./appInjector": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_reduxjs_toolkit_dist_redux-toolkit_esm_js-node_modules_sentry_core_esm_e-ce4bdb"), __webpack_require__.e("vendors-node_modules_mui_material_Box_Box_js-node_modules_mui_material_Button_Button_js-node_-fe2143"), __webpack_require__.e("src_components_ErrorPage_tsx-src_routes_Root_tsx"), __webpack_require__.e("src_appInjector_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/appInjector */ "./src/appInjector.tsx")))));
	},
	"./store": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_reduxjs_toolkit_dist_redux-toolkit_esm_js-node_modules_sentry_core_esm_e-ce4bdb"), __webpack_require__.e("src_redux_store_ts")]).then(() => (() => ((__webpack_require__(/*! ./src/redux/store */ "./src/redux/store.ts")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});